import React from "react";

const Condition = (props) => {
    
    return (
        <h4>Condition: {props.condition}</h4>
    )
}

export default Condition;